import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import ErrorView from '.';
import useTrackPageView from '../../hooks/useTrackPageView';
import type { RootState } from '../../reducers';
import { isItemUrl } from '../../utils/url';
import MissingItemError from './missing-item-error';

const Selector = () => {
  const path = useSelector<RootState, string>((s) => s.routing.path);
  const trackPageViewEvent = useTrackPageView();

  useEffect(() => {
    trackPageViewEvent();
  }, []);

  if (isItemUrl(path)) {
    return <MissingItemError />;
  }
  return <ErrorView />;
};

export default Selector;
